/**
 * click : 클릭형
 * auto : 오프뷰잉, 자동적립
 * macro : 자동클릭
 * post : 게시형
 */
export enum ViewingType {
  AUTO = 'auto',
  CLICK = 'click',
  MACRO = 'macro',
  POST = 'post',
}
